import React, {useState} from 'react';
import {Modal} from 'src/design-system';
import {Text, View} from 'react-native';
import {Colors, Typography} from 'src/styles';
import {RHButton} from 'src/common-components/custom-ui-helpers';
import {useStyle} from 'src/providers/style';
import {useTranslations} from 'src/providers/translation';
import {TouchableOpacity} from 'react-native';

const CompleteAmendModal = ({endCallback}: any) => {
  const styles = useStyle();
  const translations = useTranslations();
  const [openEndSessionModal, setOpenEndSessionModal] =
    useState<boolean>(false);

  return (
    <Modal
      show={[openEndSessionModal, setOpenEndSessionModal]}
      title={'Complete Amendment'}
      anchor={
        <TouchableOpacity
          style={[
            styles.border,
            styles.borderColorWhite,
            styles.borderRadiusSM,
            styles.paddingMHorizontal,
            styles.paddingXS,
          ]}>
          <Text
            style={[
              Typography.P3,
              styles.textColorWhite,
              styles.textTransformUppercase,
            ]}>
            {translations('end')}
          </Text>
        </TouchableOpacity>
      }>
      <>
        <Text style={[Typography.P3, styles.paddingBottom]}>
          This will complete the amendment for this session, are you sure you
          want to continue?
        </Text>
        <View
          style={[
            styles.row,
            styles.justifySpaceBetween,
            styles.alignCenter,
            styles.paddingTop,
          ]}>
          <RHButton
            secondary
            onPress={() => setOpenEndSessionModal(false)}
            textColor={Colors.RAVEN_BLACK}
            color="black"
            mode="outlined">
            {translations('cancel_button')}
          </RHButton>
          <RHButton mode="contained" onPress={endCallback}>
            Complete Amendment
          </RHButton>
        </View>
      </>
    </Modal>
  );
};

export default CompleteAmendModal;
